import {DEPARTMENT} from "./department.enum";

export interface TrackData {
	payload: {
		response: {
			chat_settings?: Settings;
			oems?: string;
		}
		params: Record<string, any>;
	};
}

export interface PickupLine {
	payload: {
		pickup_line: string;
	};
}

export interface Settings {
    gpt_settings: {
        human_chat_text: string;
        should_show_chat_with_human: boolean;
        department_selection: {
            is_enabled: boolean;
            urls: Record<DEPARTMENT, string | null>;
        };
    },
    logo_url: string | null;
}

export enum VIEW_MODE {
	NOTIFICATION = 'notification',
	WIDGET = 'widget',
}

export const REPORTING_IDENTIFIER = 'FullpathGpt';
